import { useQuery } from '@tanstack/react-query';
import { Link } from 'react-router-dom';
import { Users, ArrowRight } from 'lucide-react';
import { api } from '../../api.js';
import { Card, EmptyState, PageHeader, Spinner, Badge } from '../../components/ui.jsx';

export default function GroupsListPage() {
  const { data, isLoading } = useQuery({ queryKey: ['groups'], queryFn: api.listGroups });
  if (isLoading) return <div className="min-h-[40vh] grid place-items-center"><Spinner className="w-8 h-8 text-primary-600" /></div>;

  const groups = data?.groups || [];

  return (
    <>
      <PageHeader title="Groups" description="Browse capability data by team." />
      {groups.length === 0 ? (
        <EmptyState icon={Users} title="No groups configured yet"
          description="Set up your organisation structure to see team-level insights." />
      ) : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4">
          {groups.map(g => (
            <Link key={g.id} to={`/insights/groups/${g.id}`}
              className="block p-5 rounded-card bg-white border border-ink-200 shadow-soft hover:border-primary-300 hover:shadow-glow transition-all">
              <div className="flex items-start justify-between mb-2">
                <Badge variant="purple">{g.department_type ? g.department_type.replace(/_/g, ' ') : 'Group'}</Badge>
                <ArrowRight className="w-4 h-4 text-ink-400" />
              </div>
              <h3 className="text-base font-semibold text-ink-900">{g.name}</h3>
              <p className="text-xs text-ink-500 mt-1">{g.member_count} member{g.member_count === 1 ? '' : 's'}</p>
            </Link>
          ))}
        </div>
      )}
    </>
  );
}
